/* eslint-disable @angular-eslint/component-class-suffix */
import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, AbstractControl } from '@angular/forms';
import { Subscription } from 'rxjs';

export interface CsvPaymentItem {
	['SP Name']: string;
	['Tenant']: string;
	['SP Bank account name']: string;
	['Bank account type\nCheque = 1\nSaving = 2']: string;
	['Bank account branch']: string;
	['Bank account number']: string;
	['Amount']: number;
	['Beneficiary statement reference']: string;
	['SP POP email']: string;
	['SP SMS']: string;
}

@Component({
	selector: 'flx-csv-item',
	templateUrl: 'csv-payment-item.component.html',
	styleUrls: ['csv-payment-item.component.scss']
})
export class CSVPaymentItemOrganism implements OnInit, OnDestroy {
	// variables
	CsvPaymentForm!: UntypedFormGroup;
	private _payItem!: CsvPaymentItem;
	public sp_name!: string;
	public tenant_name!: string;
	public bank_name!: string;
	public account_type!: string;
	public bank_branch!: string;
	public acc_number!: string;
	public amount!: number;
	public statement_ref!: string;
	public sp_email!: string;
	public sps_sms!: string;

	// tslint:disable-next-line:no-output-on-prefix
	@Output() exludeItemAction = new EventEmitter<{ item: CsvPaymentItem; exclude: boolean }>();
	checkValueSub?: Subscription;

	@Input()
	set paymentitem(val: CsvPaymentItem) {
		this._payItem = val;
	}
	get paymentitem(): CsvPaymentItem {
		return this._payItem;
	}

	constructor(private fb: UntypedFormBuilder) {}

	ngOnInit() {
		this.CsvPaymentForm = this.fb.group({
			exclude_from_csv: [false]
		});
		const excludeControl: AbstractControl | null = this.CsvPaymentForm.get('exclude_from_csv');
		if (excludeControl) {
			this.checkValueSub = excludeControl.valueChanges.subscribe((exclude: boolean) => {
				// this.exludeItemAction.emit('emitting');
				this.exludeItemAction.emit({ item: this.paymentitem, exclude });
			});
		}
		this.sp_name = this.paymentitem['SP Name'];
		this.tenant_name = this.paymentitem['Tenant'];
		this.bank_name = this.paymentitem['SP Bank account name'];
		this.account_type = this.paymentitem['Bank account type\nCheque = 1\nSaving = 2'];
		this.bank_branch = this.paymentitem['Bank account branch'];
		this.acc_number = this.paymentitem['Bank account number'];
		this.amount = this.paymentitem['Amount'];
		this.statement_ref = this.paymentitem['Beneficiary statement reference'];
		this.sp_email = this.paymentitem['SP POP email'];
		this.sps_sms = this.paymentitem['SP SMS'];
	}
	ngOnDestroy() {
		if (this.checkValueSub) {
			this.checkValueSub.unsubscribe();
		}
	}
}
